/**
 * Halo d'un code activité : ses trois premiers segments (`I.02.08` pour `I.02.08.01`). Les
 * déclinaisons d'un même halo sont les rédactions de référence les plus proches d'une
 * nouvelle déclinaison : elles servent de sources de pré-remplissage, à relire et modifier
 * avant l'enregistrement.
 */
export function activitesDuHalo<T extends { codeActivite: string }>(activites: T[], halo: string): T[] {
  if (!halo) return [];
  return activites
    .filter((a) => a.codeActivite.startsWith(`${halo}.`) && a.codeActivite.split('.').length === 4)
    .sort((a, b) => a.codeActivite.localeCompare(b.codeActivite));
}

/** Vrai si le formulaire porte déjà une saisie qu'un pré-remplissage écraserait. */
export function saisieEnCours(
  redaction: { intituleActivite: string; intituleCompetence: string; detailsActivite: string[]; detailsCompetence: string[] },
  nbDomaines: number,
): boolean {
  const rempli = (v: string) => v.trim() !== '';
  return (
    rempli(redaction.intituleActivite) ||
    rempli(redaction.intituleCompetence) ||
    redaction.detailsActivite.some(rempli) ||
    redaction.detailsCompetence.some(rempli) ||
    nbDomaines > 0
  );
}
